var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content album-detail-page album-studio" },
    [
      _c(
        "el-form",
        {
          ref: "updateAlbumRequest",
          staticClass: "demo-ruleForm album-form",
          attrs: {
            model: _vm.updateAlbumRequest,
            rules: _vm.rules,
            "label-width": "120px",
          },
        },
        [
          _c("div", { staticClass: "page-header-card" }, [
            _c("div", { staticClass: "album-heading" }, [
              _c("div", { staticClass: "album-heading__icon" }, [
                _c("i", {
                  staticClass: "el-icon-picture-outline",
                  attrs: { "aria-hidden": "true" },
                }),
              ]),
              _c("div", [
                _c("span", { staticClass: "album-heading__eyebrow" }, [
                  _vm._v("THƯ VIỆN ẢNH"),
                ]),
                _c("h2", { staticClass: "page-title" }, [
                  _vm._v("Chi tiết album"),
                ]),
                _c("p", { staticClass: "page-description" }, [
                  _vm._v(
                    "\n          Chỉnh sửa thông tin album, thêm ảnh mới hoặc duyệt ảnh đã tải lên.\n        "
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "header-badges" }, [
              _c("div", { staticClass: "summary-badge" }, [
                _c("span", { staticClass: "summary-badge__label" }, [
                  _vm._v("Đối tượng"),
                ]),
                _c("strong", { staticClass: "summary-badge__value" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.updateAlbumRequest.selectObject === "student"
                          ? "Lớp"
                          : "Trường"
                      ) +
                      "\n          "
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "summary-badge summary-badge--highlight" },
                [
                  _c("span", { staticClass: "summary-badge__label" }, [
                    _vm._v("Ảnh đã duyệt"),
                  ]),
                  _c("strong", { staticClass: "summary-badge__value" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.updateAlbumRequest.pictureApprovedNumber || 0
                        ) +
                        "/" +
                        _vm._s(_vm.updateAlbumRequest.pictureNumber || 0) +
                        "\n          "
                    ),
                  ]),
                ]
              ),
              _c("div", { staticClass: "summary-badge" }, [
                _c("span", { staticClass: "summary-badge__label" }, [
                  _vm._v("Trạng thái album"),
                ]),
                _c("strong", { staticClass: "summary-badge__value" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.updateAlbumRequest.albumApproved
                          ? "Đang hiện"
                          : "Đã ẩn"
                      ) +
                      "\n          "
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "form-shell" }, [
            _c("div", { staticClass: "album-form-main" }, [
              _c(
                "section",
                { staticClass: "section-card album-info-section" },
                [
                  _c("div", { staticClass: "section-heading" }, [
                    _c("h3", { staticClass: "section-title" }, [
                      _c("i", {
                        staticClass: "el-icon-document",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v("Thông tin album"),
                    ]),
                    _c("p", { staticClass: "section-description" }, [
                      _vm._v("Chỉnh sửa tên, đối tượng và mô tả album."),
                    ]),
                  ]),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "field-item",
                              attrs: { label: "Tên album", prop: "albumName" },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "Nhập tiêu đề..." },
                                model: {
                                  value: _vm.updateAlbumRequest.albumName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.updateAlbumRequest,
                                      "albumName",
                                      $$v
                                    )
                                  },
                                  expression: "updateAlbumRequest.albumName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { xs: 24, md: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "field-item",
                              attrs: { label: "Đối tượng" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "full-width",
                                  attrs: {
                                    "popper-class": "album-studio-popper",
                                    placeholder: "Chọn đối tượng",
                                  },
                                  on: { change: _vm.handleChangeObject },
                                  model: {
                                    value: _vm.updateAlbumRequest.selectObject,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.updateAlbumRequest,
                                        "selectObject",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "updateAlbumRequest.selectObject",
                                  },
                                },
                                _vm._l(_vm.listSelectObject, function (item) {
                                  return _c(
                                    "el-option",
                                    {
                                      key: item.id,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    },
                                    [_c("span", [_vm._v(_vm._s(item.label))])]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "description-item",
                      attrs: { label: "Mô tả album", prop: "desc" },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "Nhập nội dung...",
                          rows: 3,
                          type: "textarea",
                        },
                        model: {
                          value: _vm.updateAlbumRequest.albumDescription,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.updateAlbumRequest,
                              "albumDescription",
                              $$v
                            )
                          },
                          expression: "updateAlbumRequest.albumDescription",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.updateAlbumRequest.selectObject === "student"
                ? _c(
                    "section",
                    { staticClass: "section-card album-audience-section" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "section-heading section-heading--space-between",
                        },
                        [
                          _c("div", [
                            _c("h3", { staticClass: "section-title" }, [
                              _c("i", {
                                staticClass: "el-icon-user",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v("Phạm vi học sinh"),
                            ]),
                            _c("p", { staticClass: "section-description" }, [
                              _vm._v(
                                "Chọn học sinh áp dụng cho album theo từng lớp."
                              ),
                            ]),
                          ]),
                          _c(
                            "Phase2ActionButton",
                            {
                              staticClass: "student-select-button",
                              attrs: { type: "primary", icon: "el-icon-user" },
                              on: { click: _vm.clickSelectStudent },
                            },
                            [
                              _vm._v(
                                "\n              Chọn học sinh trong lớp\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "student-list-panel" }, [
                        _c(
                          "div",
                          { staticClass: "student-list-panel__header" },
                          [
                            _c("div", [
                              _c("h4", { staticClass: "student-list-title" }, [
                                _vm._v("Danh sách học sinh"),
                              ]),
                              _c(
                                "span",
                                { staticClass: "student-list-subtitle" },
                                [
                                  _vm._v(
                                    "\n                  Đã chọn " +
                                      _vm._s(
                                        _vm.updateAlbumRequest.kids
                                          ? _vm.updateAlbumRequest.kids.length
                                          : 0
                                      ) +
                                      " học sinh\n                "
                                  ),
                                ]
                              ),
                            ]),
                            _vm.updateAlbumRequest.kids &&
                            _vm.updateAlbumRequest.kids.length
                              ? _c("el-input", {
                                  staticClass: "student-list-search",
                                  attrs: {
                                    clearable: "",
                                    "prefix-icon": "el-icon-search",
                                    placeholder: "Tìm theo tên hoặc lớp",
                                    label: "Tìm học sinh đã chọn",
                                  },
                                  model: {
                                    value: _vm.selectedStudentSearch,
                                    callback: function ($$v) {
                                      _vm.selectedStudentSearch = $$v
                                    },
                                    expression: "selectedStudentSearch",
                                  },
                                })
                              : _vm._e(),
                            _vm.selectedStudentSearch.trim()
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "student-search-count",
                                    attrs: { role: "status" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                Tìm thấy " +
                                        _vm._s(
                                          _vm.filteredSelectedKids.length
                                        ) +
                                        " học sinh\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        !_vm.updateAlbumRequest.kids ||
                        _vm.updateAlbumRequest.kids.length === 0
                          ? _c("div", { staticClass: "student-empty-state" }, [
                              _c("i", {
                                staticClass:
                                  "el-icon-user-solid student-empty-state__icon",
                              }),
                              _c(
                                "div",
                                { staticClass: "student-empty-state__title" },
                                [_vm._v("Chưa có học sinh nào được chọn")]
                              ),
                              _c(
                                "div",
                                { staticClass: "student-empty-state__desc" },
                                [
                                  _vm._v("\n                Nhấn "),
                                  _c("strong", [
                                    _vm._v("Chọn học sinh trong lớp"),
                                  ]),
                                  _vm._v(
                                    " để thêm học sinh vào album này.\n              "
                                  ),
                                ]
                              ),
                            ])
                          : _vm.filteredSelectedKids.length === 0
                          ? _c(
                              "div",
                              {
                                staticClass: "student-search-empty",
                                attrs: { role: "status" },
                              },
                              [
                                _vm._v(
                                  "\n              Không tìm thấy học sinh phù hợp.\n            "
                                ),
                              ]
                            )
                          : _c(
                              "div",
                              { staticClass: "answer_apply" },
                              _vm._l(
                                _vm.filteredSelectedKids,
                                function (kid, index) {
                                  return _c(
                                    "div",
                                    { key: index, staticClass: "kid-row" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "kid-row__icon-wrap" },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-circle-check kid-row__icon",
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "kid-row__content" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "kid-row__name" },
                                            [_vm._v(_vm._s(kid.kidsName))]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "kid-row__meta" },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.parseKidStatusVietnamese(
                                                      kid.statusKids
                                                    )
                                                  ) +
                                                  " • " +
                                                  _vm._s(kid.className) +
                                                  "\n                  "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]),
            _c(
              "section",
              { staticClass: "section-card album-upload-section" },
              [
                _c("div", { staticClass: "section-heading" }, [
                  _c("h3", { staticClass: "section-title" }, [
                    _c("i", {
                      staticClass: "el-icon-upload",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v("Thêm ảnh mới"),
                  ]),
                  _c("p", { staticClass: "section-description" }, [
                    _vm._v(
                      "Kéo thả hoặc chọn thêm ảnh, kiểm tra trước khi lưu vào album."
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "upload-toolbar" }, [
                  _c("div", { staticClass: "upload-left" }, [
                    _c("div", { staticClass: "upload-note-card" }, [
                      _c("span", { staticClass: "upload-note-card__label" }, [
                        _vm._v("Đang chờ tải lên"),
                      ]),
                      _c("strong", { staticClass: "upload-note-card__value" }, [
                        _vm._v(_vm._s(_vm.fileList.length) + " ảnh"),
                      ]),
                    ]),
                    _vm.fileList && _vm.fileList.length > 0
                      ? _c("div", { staticClass: "selected-summary" }, [
                          _c("img", {
                            staticClass: "selected-summary__thumb",
                            attrs: { src: _vm.fileList[0].url, alt: "ảnh" },
                          }),
                          _c("div", { staticClass: "selected-summary__text" }, [
                            _vm._v(
                              _vm._s(_vm.fileList.length) + " ảnh đã chọn"
                            ),
                          ]),
                        ])
                      : _c("div", { staticClass: "selected-summary" }, [
                          _c(
                            "div",
                            { staticClass: "selected-summary__empty" },
                            [_vm._v("Chưa có ảnh mới")]
                          ),
                        ]),
                  ]),
                  _c("div", { staticClass: "upload-right" }, [
                    _vm.showProgress
                      ? _c(
                          "div",
                          { staticClass: "progress-wrap" },
                          [
                            _c("el-progress", {
                              staticClass: "upload-progress",
                              attrs: {
                                percentage: _vm.percentage,
                                color: _vm.colors,
                              },
                            }),
                            _c("div", { staticClass: "progress-label" }, [
                              _vm._v(_vm._s(_vm.percentage) + "%"),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]),
                _c("el-upload", {
                  ref: "upload",
                  staticClass: "upload-area",
                  attrs: {
                    action: "#",
                    drag: "",
                    "list-type": "picture-card",
                    "auto-upload": false,
                    "file-list": _vm.fileList,
                    "on-change": _vm.handleChangePicture,
                    "on-remove": _vm.handleRemove,
                    multiple: "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "upload-trigger" }, [
                            _c("i", {
                              staticClass:
                                "el-icon-upload upload-trigger__icon",
                              attrs: { "aria-hidden": "true" },
                            }),
                            _c(
                              "strong",
                              { staticClass: "upload-trigger__text" },
                              [_vm._v("Kéo thả ảnh vào đây")]
                            ),
                            _c(
                              "span",
                              { staticClass: "upload-trigger__description" },
                              [
                                _vm._v(
                                  "Chọn nhiều ảnh cùng lúc hoặc bấm để chọn từ máy"
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              { staticClass: "upload-trigger__button" },
                              [
                                _c("i", {
                                  staticClass: "el-icon-plus",
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _vm._v(" Chọn ảnh từ máy"),
                              ]
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "file",
                      fn: function ({ file }) {
                        return [
                          _c(
                            "div",
                            { staticClass: "container_image_upload" },
                            [
                              _c("TagFlag", { attrs: { title: "Mới" } }),
                              _c("img", {
                                staticClass: "el-upload-list__item-thumbnail",
                                attrs: {
                                  src: _vm.getPreview(file),
                                  alt: "Ảnh mới",
                                },
                              }),
                              _c(
                                "div",
                                { staticClass: "upload-thumbnail-actions" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "upload-thumbnail-action",
                                      attrs: {
                                        type: "button",
                                        "aria-label": "Xem ảnh " + file.name,
                                        title: "Xem ảnh",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.handlePictureCardPreview(
                                            file
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-zoom-in",
                                        attrs: { "aria-hidden": "true" },
                                      }),
                                    ]
                                  ),
                                  !_vm.disabled
                                    ? _c(
                                        "button",
                                        {
                                          staticClass:
                                            "upload-thumbnail-action upload-thumbnail-action--delete",
                                          attrs: {
                                            type: "button",
                                            "aria-label": "Bỏ ảnh " + file.name,
                                            title: "Bỏ ảnh",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.handleRemove(file)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-delete",
                                            attrs: { "aria-hidden": "true" },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("div", { staticClass: "upload-help-text" }, [
                  _vm._v(
                    "JPG/PNG, tối đa 5MB/ảnh · Ảnh mới sẽ được bổ sung khi lưu"
                  ),
                ]),
                _c(
                  "el-dialog",
                  {
                    staticClass: "album-studio-upload-preview",
                    attrs: {
                      title: "Xem ảnh mới",
                      width: "70%",
                      visible: _vm.dialogVisible,
                      top: "32px",
                    },
                    on: {
                      "update:visible": function ($event) {
                        _vm.dialogVisible = $event
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        width: "100%",
                        src: _vm.dialogImageUrl,
                        alt: "",
                      },
                    }),
                  ]
                ),
              ],
              1
            ),
            _c(
              "section",
              { staticClass: "section-card album-gallery-section" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "section-heading section-heading--space-between",
                  },
                  [
                    _c("div", [
                      _c("h3", { staticClass: "section-title" }, [
                        _c("i", {
                          staticClass: "el-icon-picture-outline",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v("Danh sách ảnh album\n              "),
                        _vm.updateAlbumRequest.albumName
                          ? _c("span", { staticClass: "album-name-inline" }, [
                              _vm._v(
                                "\n                — " +
                                  _vm._s(_vm.updateAlbumRequest.albumName) +
                                  "\n              "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _c("p", { staticClass: "section-description" }, [
                        _vm._v("Xem, duyệt hoặc xóa ảnh đã có trong album."),
                      ]),
                    ]),
                    _c("div", { staticClass: "picture-section-actions" }, [
                      Array.isArray(_vm.updateAlbumRequest.alistPictureList)
                        ? _c("div", { staticClass: "picture-count-badge" }, [
                            _c("i", { staticClass: "el-icon-picture" }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.updateAlbumRequest.alistPictureList.length
                                ) +
                                " ảnh\n            "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                ),
                _vm.detailLoading
                  ? _c(
                      "div",
                      {
                        staticClass: "album-load-state",
                        attrs: { role: "status", "aria-live": "polite" },
                      },
                      [
                        _c("i", { staticClass: "el-icon-loading" }),
                        _vm._v(" Đang tải ảnh album…\n        "),
                      ]
                    )
                  : _vm.detailError
                  ? _c(
                      "div",
                      {
                        staticClass: "album-load-state album-load-state--error",
                        attrs: { role: "alert" },
                      },
                      [
                        _c("i", { staticClass: "el-icon-warning-outline" }),
                        _vm._v(" Không tải được chi tiết album.\n          "),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", icon: "el-icon-refresh" },
                            on: { click: _vm.getAlumDetail },
                          },
                          [_vm._v("Thử lại")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.detailLoading &&
                !_vm.detailError &&
                _vm.alistPictureList.length
                  ? _c(
                      "div",
                      {
                        staticClass: "album-picture-filters",
                        attrs: {
                          role: "group",
                          "aria-label": "Lọc trạng thái ảnh",
                        },
                      },
                      _vm._l(_vm.pictureFilters, function (filter) {
                        return _c(
                          "button",
                          {
                            key: filter.value,
                            class: {
                              "is-active": _vm.pictureFilter === filter.value,
                            },
                            attrs: {
                              type: "button",
                              "aria-pressed":
                                _vm.pictureFilter === filter.value,
                            },
                            on: {
                              click: function ($event) {
                                _vm.pictureFilter = filter.value
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " + _vm._s(filter.label) + " "
                            ),
                            _c("span", [_vm._v(_vm._s(filter.count))]),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                !_vm.detailLoading &&
                !_vm.detailError &&
                _vm.alistPictureList.length
                  ? _c(
                      "div",
                      { staticClass: "picture-selection-bar" },
                      [
                        _c(
                          "el-checkbox",
                          {
                            attrs: {
                              indeterminate: _vm.pictureSelectionIndeterminate,
                              disabled:
                                _vm.deletePictureLoading ||
                                _vm.pictureApprovalLoading ||
                                !_vm.visiblePictures.length,
                            },
                            on: { change: _vm.handleCheckAllPictures },
                            model: {
                              value: _vm.checkAllPictures,
                              callback: function ($$v) {
                                _vm.checkAllPictures = $$v
                              },
                              expression: "checkAllPictures",
                            },
                          },
                          [_vm._v("Chọn ảnh đang hiển thị")]
                        ),
                        _vm.selectedPictureIdxs.length > 0
                          ? _c(
                              "span",
                              { staticClass: "picture-selection-bar__count" },
                              [
                                _vm._v(
                                  "\n            Đã chọn " +
                                    _vm._s(_vm.selectedPictureIdxs.length) +
                                    " ảnh\n            "
                                ),
                                _vm.hiddenSelectedPictureCount
                                  ? _c("small", [
                                      _vm._v(
                                        "(" +
                                          _vm._s(
                                            _vm.hiddenSelectedPictureCount
                                          ) +
                                          " ảnh ngoài bộ lọc)"
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                        _vm.selectedPictureIdxs.length
                          ? [
                              _vm.checkPermission([
                                "studentQuality_ablum_update",
                              ])
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "picture-selection-bar__actions",
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "small",
                                            type: "primary",
                                            icon: "el-icon-check",
                                            loading:
                                              _vm.pictureApprovalLoading &&
                                              _vm.pictureApprovalTarget,
                                            disabled:
                                              _vm.pictureApprovalLoading ||
                                              _vm.deletePictureLoading,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.updateAllPictureApproval(
                                                true
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "Duyệt " +
                                              _vm._s(
                                                _vm.selectedPictureIdxs.length
                                              ) +
                                              " ảnh"
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "small",
                                            icon: "el-icon-close",
                                            loading:
                                              _vm.pictureApprovalLoading &&
                                              !_vm.pictureApprovalTarget,
                                            disabled:
                                              _vm.pictureApprovalLoading ||
                                              _vm.deletePictureLoading,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.updateAllPictureApproval(
                                                false
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "Hủy duyệt " +
                                              _vm._s(
                                                _vm.selectedPictureIdxs.length
                                              ) +
                                              " ảnh"
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "small",
                                            type: "danger",
                                            plain: "",
                                            icon: "el-icon-delete",
                                            loading: _vm.deletePictureLoading,
                                            disabled:
                                              _vm.pictureApprovalLoading ||
                                              _vm.deletePictureLoading,
                                          },
                                          on: {
                                            click: _vm.deleteSelectedPictures,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "Xóa " +
                                              _vm._s(
                                                _vm.selectedPictureIdxs.length
                                              ) +
                                              " ảnh"
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "text",
                                    disabled:
                                      _vm.pictureApprovalLoading ||
                                      _vm.deletePictureLoading,
                                  },
                                  on: { click: _vm.resetPictureSelection },
                                },
                                [_vm._v("Bỏ chọn")]
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  : _vm._e(),
                !_vm.detailLoading &&
                !_vm.detailError &&
                _vm.visiblePictures.length
                  ? _c(
                      "div",
                      {
                        staticClass: "picture-grid",
                        attrs: {
                          role: "region",
                          "aria-label": "Danh sách ảnh album",
                          tabindex: "0",
                        },
                      },
                      _vm._l(_vm.visiblePictures, function (listPicture) {
                        return _c(
                          "div",
                          {
                            key: _vm.getPictureIdx(listPicture),
                            staticClass: "picture-card",
                            class: {
                              "picture-card--selected": listPicture.checkDelete,
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "picture-card__img-wrap" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "album-picture-open",
                                    attrs: {
                                      type: "button",
                                      "aria-label":
                                        "Xem ảnh " +
                                        (_vm.alistPictureList.indexOf(
                                          listPicture
                                        ) +
                                          1),
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.handleShowDetailPicture(
                                          _vm.alistPictureList.indexOf(
                                            listPicture
                                          ),
                                          listPicture,
                                          $event
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content: "Xem ảnh",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        listPicture.urlPictureShow &&
                                        !listPicture.imageError
                                          ? _c(
                                              "el-image",
                                              {
                                                staticClass:
                                                  "picture-card__img el-image-opacity",
                                                attrs: {
                                                  src: listPicture.urlPictureShow,
                                                  fit: "cover",
                                                },
                                                on: {
                                                  error: function ($event) {
                                                    return _vm.handleAlbumImageError(
                                                      listPicture
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "picture-card__image-loading",
                                                    attrs: {
                                                      slot: "placeholder",
                                                    },
                                                    slot: "placeholder",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-loading",
                                                    }),
                                                    _c("span", [
                                                      _vm._v("Đang tải ảnh"),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "picture-card__image-fallback",
                                              },
                                              [
                                                _c("i", {
                                                  class:
                                                    listPicture.imageLoading
                                                      ? "el-icon-loading"
                                                      : "el-icon-picture-outline",
                                                }),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      listPicture.imageLoading
                                                        ? "Đang tải ảnh"
                                                        : "Không tải được ảnh"
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                listPicture.imageError &&
                                !listPicture.imageLoading
                                  ? _c(
                                      "el-button",
                                      {
                                        staticClass: "album-image-retry",
                                        attrs: {
                                          size: "mini",
                                          icon: "el-icon-refresh",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.retryAlbumImage(
                                              listPicture
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Thử lại")]
                                    )
                                  : _vm._e(),
                                listPicture.representative ||
                                listPicture.isRepresentative ||
                                listPicture.isAvatar
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "picture-card__representative-badge",
                                        attrs: {
                                          title: "Ảnh đại diện album",
                                          "aria-label": "Ảnh đại diện album",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-star-on",
                                          attrs: { "aria-hidden": "true" },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass: "picture-card__badge",
                                    class: listPicture.isApproved
                                      ? "badge--approved"
                                      : "badge--pending",
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          listPicture.isApproved
                                            ? "Đã duyệt"
                                            : "Chờ duyệt"
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "picture-card__selection" },
                              [
                                _c(
                                  "el-checkbox",
                                  {
                                    staticClass: "picture-card__select",
                                    attrs: {
                                      disabled:
                                        _vm.deletePictureLoading ||
                                        _vm.pictureApprovalLoading,
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.handlePictureSelectionChange(
                                          listPicture
                                        )
                                      },
                                    },
                                    model: {
                                      value: listPicture.checkDelete,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          listPicture,
                                          "checkDelete",
                                          $$v
                                        )
                                      },
                                      expression: "listPicture.checkDelete",
                                    },
                                  },
                                  [_vm._v("Chọn ảnh")]
                                ),
                              ],
                              1
                            ),
                            _vm.checkPermission(["studentQuality_ablum_update"])
                              ? _c(
                                  "div",
                                  { staticClass: "picture-card__actions" },
                                  [
                                    !listPicture.isApproved
                                      ? _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              content: "Duyệt ảnh",
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c("el-button", {
                                              staticClass:
                                                "picture-card__btn picture-card__btn--approve",
                                              attrs: {
                                                type: "primary",
                                                size: "mini",
                                                icon: "el-icon-check",
                                                "aria-label": "Duyệt ảnh",
                                                disabled:
                                                  _vm.pictureApprovalLoading,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.updateApprovePicture(
                                                    listPicture.pictureIdx,
                                                    true
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "el-tooltip",
                                          {
                                            attrs: {
                                              content: "Hủy duyệt ảnh",
                                              placement: "top",
                                            },
                                          },
                                          [
                                            _c("el-button", {
                                              staticClass:
                                                "picture-card__btn picture-card__btn--approved",
                                              attrs: {
                                                type: "warning",
                                                size: "mini",
                                                icon: "el-icon-close",
                                                "aria-label": "Hủy duyệt ảnh",
                                                disabled:
                                                  _vm.pictureApprovalLoading,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.updateApprovePicture(
                                                    listPicture.pictureIdx,
                                                    false
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content: "Xóa ảnh",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("el-button", {
                                          staticClass:
                                            "picture-card__btn picture-card__btn--delete",
                                          attrs: {
                                            type: "danger",
                                            size: "mini",
                                            icon: "el-icon-delete",
                                            "aria-label": "Xóa ảnh",
                                            loading:
                                              _vm.deletePictureLoading &&
                                              _vm.deletingPictureIdxs.includes(
                                                String(listPicture.pictureIdx)
                                              ),
                                            disabled:
                                              _vm.deletePictureLoading ||
                                              _vm.pictureApprovalLoading,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteSinglePicture(
                                                listPicture
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    )
                  : !_vm.detailLoading && !_vm.detailError
                  ? _c("div", { staticClass: "pictures-empty-state" }, [
                      _c("i", {
                        staticClass:
                          "el-icon-picture-outline pictures-empty-state__icon",
                      }),
                      _c(
                        "div",
                        { staticClass: "pictures-empty-state__title" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.alistPictureList.length
                                ? "Không có ảnh trong trạng thái này"
                                : "Album chưa có ảnh nào"
                            )
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "pictures-empty-state__desc" }, [
                        _vm._v(
                          _vm._s(
                            _vm.alistPictureList.length
                              ? "Chọn trạng thái khác để tiếp tục xem ảnh."
                              : "Hãy tải ảnh lên ở phần Thêm ảnh mới phía trên."
                          )
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]
            ),
          ]),
          _c("div", { staticClass: "actions-footer" }, [
            _c("div", { staticClass: "actions-footer__left" }, [
              _c("span", { staticClass: "meta-author" }, [
                _c("strong", [_vm._v("Người đăng:")]),
                _vm._v(" " + _vm._s(_vm.updateAlbumRequest.createdBy)),
              ]),
              _c("span", { staticClass: "meta-divider" }, [_vm._v("|")]),
              _c("span", { staticClass: "meta-info" }, [
                _vm._v(
                  _vm._s(_vm.updateAlbumRequest.pictureApprovedNumber) +
                    "/" +
                    _vm._s(_vm.updateAlbumRequest.pictureNumber) +
                    " ảnh"
                ),
              ]),
              _c("span", { staticClass: "meta-divider" }, [_vm._v("|")]),
              _c("span", { staticClass: "meta-info" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("formatDate")(_vm.updateAlbumRequest.createdDate)
                  )
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "actions-footer__right" },
              [
                _vm.checkPermission(["studentQuality_ablum_update"])
                  ? _c(
                      "Phase2ActionButton",
                      {
                        attrs: {
                          type: "primary",
                          size: "small",
                          icon: "el-icon-circle-check",
                          loading: _vm.loadingButton,
                          disabled:
                            _vm.loadingButton ||
                            _vm.compressingCount > 0 ||
                            _vm.detailLoading ||
                            _vm.detailError,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.submitUpload("updateAlbumRequest")
                          },
                        },
                      },
                      [_vm._v("\n          Lưu thay đổi\n        ")]
                    )
                  : _vm._e(),
                _c(
                  "router-link",
                  { staticClass: "cancel-link", attrs: { to: "/album-v2" } },
                  [
                    _c(
                      "Phase2ActionButton",
                      {
                        attrs: {
                          type: "default",
                          size: "small",
                          icon: "el-icon-back",
                        },
                      },
                      [_vm._v("\n            Quay lại\n          ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm.showUpdateProgress
        ? _c(
            "div",
            {
              staticClass:
                "album-update-progress-overlay album-studio-progress",
              attrs: { role: "status", "aria-live": "polite" },
            },
            [
              _c(
                "div",
                { staticClass: "album-update-progress-card" },
                [
                  _c("i", {
                    staticClass:
                      "el-icon-loading album-update-progress-card__icon",
                  }),
                  _c(
                    "h3",
                    { staticClass: "album-update-progress-card__title" },
                    [_vm._v(_vm._s(_vm.updateProgressTitle))]
                  ),
                  _c(
                    "p",
                    { staticClass: "album-update-progress-card__message" },
                    [_vm._v(_vm._s(_vm.updateProgressMessage))]
                  ),
                  _c("el-progress", {
                    staticClass: "album-update-progress-card__bar",
                    attrs: {
                      percentage: _vm.percentage,
                      color: _vm.colors,
                      "show-text": false,
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "album-update-progress-card__percent" },
                    [_vm._v(_vm._s(_vm.percentage) + "%")]
                  ),
                  _c("p", { staticClass: "album-update-progress-card__note" }, [
                    _vm._v("Vui lòng không đóng trang trong quá trình xử lý."),
                  ]),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _c("AlbumDownloadProgressDialog", {
        attrs: {
          visible: _vm.showDownloadProgress,
          indeterminate: "",
          percentage: _vm.downloadProgress,
          title: _vm.downloadProgressTitle,
          message: _vm.downloadProgressMessage,
        },
      }),
      _c(
        "el-dialog",
        {
          ref: "pictureViewer",
          staticClass: "album-preview-dialog album-studio-viewer",
          attrs: {
            fullscreen: _vm.viewerFullscreen,
            title:
              "Ảnh " + (_vm.indexSrc + 1) + " / " + _vm.alistPictureList.length,
            width: "82%",
            visible: _vm.dialogVisiblePic,
            top: "32px",
          },
          on: {
            opened: _vm.onViewerOpened,
            closed: _vm.onViewerClosed,
            "update:visible": function ($event) {
              _vm.dialogVisiblePic = $event
            },
          },
          nativeOn: {
            keydown: function ($event) {
              return _vm.handleViewerKeydown.apply(null, arguments)
            },
          },
          scopedSlots: _vm._u([
            {
              key: "title",
              fn: function () {
                return [
                  _c("div", { staticClass: "album-viewer-heading" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.updateAlbumRequest.albumName)),
                    ]),
                    _c("small", [
                      _vm._v(
                        "Ảnh " +
                          _vm._s(_vm.indexSrc + 1) +
                          " / " +
                          _vm._s(_vm.alistPictureList.length)
                      ),
                    ]),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "button-container" },
                    [
                      _c(
                        "Phase2ActionButton",
                        {
                          attrs: {
                            type: "default",
                            size: "small",
                            icon: "el-icon-d-arrow-left",
                            disabled: _vm.indexSrc <= 0,
                          },
                          on: { click: _vm.backPage },
                        },
                        [_vm._v("Trước")]
                      ),
                      _c(
                        "Phase2ActionButton",
                        {
                          attrs: {
                            type: "default",
                            size: "small",
                            icon: "el-icon-download",
                            loading: _vm.downloadingPicture,
                            disabled: _vm.downloadingPicture,
                          },
                          on: { click: _vm.downloadCurrentPicture },
                        },
                        [_vm._v("Tải ảnh")]
                      ),
                      _c(
                        "Phase2ActionButton",
                        {
                          attrs: {
                            type: "primary",
                            size: "small",
                            icon: "el-icon-picture",
                            loading: _vm.settingAvatar,
                            disabled: _vm.settingAvatar,
                          },
                          on: { click: _vm.setUpAvatarAlbum },
                        },
                        [_vm._v("\n          Đặt làm ảnh đại diện\n        ")]
                      ),
                      _c(
                        "Phase2ActionButton",
                        {
                          attrs: {
                            type: "default",
                            size: "small",
                            disabled:
                              _vm.indexSrc >= _vm.alistPictureList.length - 1,
                          },
                          on: { click: _vm.nextPage },
                        },
                        [
                          _c("span", [_vm._v("Sau")]),
                          _c("i", { staticClass: "el-icon-d-arrow-right" }),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "div",
            {
              staticClass: "album-viewer-tools",
              attrs: { role: "group", "aria-label": "Điều khiển ảnh" },
            },
            [
              _c("el-button", {
                attrs: {
                  size: "mini",
                  icon: "el-icon-zoom-out",
                  disabled: _vm.viewerZoom <= 1,
                  "aria-label": "Thu nhỏ",
                },
                on: {
                  click: function ($event) {
                    return _vm.changeViewerZoom(-0.25)
                  },
                },
              }),
              _c("span", { attrs: { "aria-live": "polite" } }, [
                _vm._v(_vm._s(Math.round(_vm.viewerZoom * 100)) + "%"),
              ]),
              _c("el-button", {
                attrs: {
                  size: "mini",
                  icon: "el-icon-zoom-in",
                  disabled: _vm.viewerZoom >= 3,
                  "aria-label": "Phóng to",
                },
                on: {
                  click: function ($event) {
                    return _vm.changeViewerZoom(0.25)
                  },
                },
              }),
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.viewerZoom = 1
                    },
                  },
                },
                [_vm._v("Vừa khung")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "mini",
                    icon: "el-icon-full-screen",
                    "aria-pressed": _vm.viewerFullscreen,
                  },
                  on: {
                    click: function ($event) {
                      _vm.viewerFullscreen = !_vm.viewerFullscreen
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.viewerFullscreen ? "Thu gọn" : "Toàn màn hình")
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "image-container",
              class: { "is-zoomed": _vm.viewerZoom > 1 },
            },
            [
              _c(
                "div",
                {
                  staticClass: "album-viewer-image-stage",
                  style: {
                    width: _vm.viewerZoom * 100 + "%",
                    height: _vm.viewerZoom * 100 + "%",
                  },
                },
                [
                  _vm.selectedImg
                    ? _c("img", {
                        staticClass: "centered-image",
                        attrs: { src: _vm.selectedImg, alt: "Ảnh album" },
                        on: { error: _vm.handlePreviewImageError },
                      })
                    : _c(
                        "div",
                        { staticClass: "picture-card__image-fallback" },
                        [
                          _c("i", {
                            class: _vm.selectedPictureLoading
                              ? "el-icon-loading"
                              : "el-icon-picture-outline",
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.selectedPictureLoading
                                  ? "Đang tải ảnh"
                                  : "Không tải được ảnh"
                              )
                            ),
                          ]),
                          !_vm.selectedPictureLoading &&
                          _vm.alistPictureList[_vm.indexSrc]
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    size: "small",
                                    icon: "el-icon-refresh",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.retryAlbumImage(
                                        _vm.alistPictureList[_vm.indexSrc]
                                      )
                                    },
                                  },
                                },
                                [_vm._v("Thử lại")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                ]
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "album-viewer-thumbnails",
              attrs: { role: "group", "aria-label": "Chuyển ảnh trong album" },
            },
            _vm._l(_vm.alistPictureList, function (picture, index) {
              return _c(
                "button",
                {
                  key: _vm.getPictureIdx(picture),
                  class: { "is-active": index === _vm.indexSrc },
                  attrs: {
                    type: "button",
                    "aria-label": "Xem ảnh " + (index + 1),
                    "aria-pressed": index === _vm.indexSrc,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.showViewerPicture(index)
                    },
                  },
                },
                [
                  picture.urlPictureShow && !picture.imageError
                    ? _c("img", {
                        attrs: { src: picture.urlPictureShow, alt: "" },
                      })
                    : _c("i", {
                        class: picture.imageLoading
                          ? "el-icon-loading"
                          : "el-icon-picture-outline",
                      }),
                  _c("span", [_vm._v(_vm._s(index + 1))]),
                ]
              )
            }),
            0
          ),
        ]
      ),
      _c("AddStudentUpdateAlbumDialog", {
        attrs: {
          kidsInSchool: _vm.kidsInSchool,
          getAppTypeUserLogin: _vm.getAppTypeUserLogin,
          initialClasses:
            _vm.updateAlbumRequest.classIds ||
            _vm.updateAlbumRequest.classes ||
            [],
          initialKidIds: _vm.updateAlbumRequest.listIdKidApply || [],
          isAddStudentUpdateAlbumDialog: _vm.isAddStudentUpdateAlbumDialog,
        },
        on: {
          closeDialog: _vm.closeAddStudentUpdateAlbumDialog,
          confirmData: _vm.handleConfirmKidsApply,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }